import { render, staticRenderFns } from "./border-refound-detail.vue?vue&type=template&id=092eea7a&scoped=true&"
import script from "./border-refound-detail.vue?vue&type=script&lang=js&"
export * from "./border-refound-detail.vue?vue&type=script&lang=js&"
import style0 from "./border-refound-detail.vue?vue&type=style&index=0&id=092eea7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092eea7a",
  null
  
)

export default component.exports